<template>
  <LaybyCard :order="order" :is-payment-plan="true" />
</template>

<script setup lang="ts">
import LaybyCard from '@/components/shopper/lay-by/LaybyCard.vue';
import type { ModelOrderResponse } from '@layup/api-sdk';

defineProps<{ order?: ModelOrderResponse }>();
</script>
